import {
  AppContext,
  BackgroundIcon,
  DateTimeFormatter
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { Receiver, Sender } from '@nile/mangifera/src/Pebbles/chat';
import { Avatar, TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import dompurify from 'dompurify';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styled from 'styled-components';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const StyledNote = styled.div`
  background: ${(props) =>
    props.user ? '#e5fdff;' : 'var(--sops-coversation-bubble-bg)'};
  border-radius: 20px 20px;
  width: 75%;
  margin-left: 12px;
  padding: 10px 15px 15px 15px;
  opacity: 1;
  transition: opacity 200ms linear;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.102874);
  .message-content {
    margin-top: 10px;
    word-break: break-word;
  }
  .action > div:first-child {
    visibility: hidden;
  }

  &:hover {
    .action > div:first-child {
      visibility: visible;
      cursor: pointer;
    }
  }
  .ap {
    background-image: url(${envConfig.imageRoot}emojis.webp);
  }
`;

function MilestoneBubble(props) {
  const { message } = props;
  const appContext = useContext(AppContext);
  const { user, company } = appContext;

  const Tags = {
    sender: Sender,
    receiver: Receiver
  };

  const userType =
    message?.user?.userId === user?.userId ? 'sender' : 'receiver';
  const Tag = Tags[userType];
  return (
    <Tag className="fx bubbleContainer">
      <div className="avatar mr8">
        <Avatar
          size="small"
          initials={`${message?.user?.firstName?.[0]}${
            message?.user?.lastName?.[0] ? message?.user?.lastName?.[0] : ''
          }`}
          source={`${envConfig.imageRoot}svg/notification.svg`}
        />
      </div>
      <SwitchTransition>
        <CSSTransition
          key={message?.id}
          timeout={200}
          in
          appear
          classNames="bubbles"
          unmountOnExit
        >
          <StyledNote
            className="bubble"
            user={message.user && userType === 'sender'}
          >
            <div className="fx">
              <div className="fx2 fx actr f-12">
                <div className="mr8">
                  <SVGIcon name="Milestone" size="sm" color="#323232" />
                </div>
                <TextStyle variation="subdued">
                  <FormattedMessage id="project.details.convoBubble.milestone" />{' '}
                  &nbsp;
                  <TextStyle variation="strong">
                    {`${message?.status}`}
                  </TextStyle>
                </TextStyle>
              </div>
              <div
                className="fx2 fx jend f-12"
                title={
                  <DateTimeFormatter type="dateTime" date={message?.time} />
                }
                // title={dayjs(message?.time).format(
                //   `${company?.dateFormat ||
                //     'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                // )}
              >
                <TextStyle variation="subdued">
                  <DateTimeFormatter type="dateTime" date={message?.time} />
                  {/* {dayjs(message?.time).format(
                    `${company?.dateFormat ||
                      'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                  )} */}
                </TextStyle>
              </div>
            </div>
            <div className="fx mt10">
              Milestone&nbsp;
              <p
                style={{ fontWeight: 'bold' }}
                dangerouslySetInnerHTML={{
                  __html: dompurifier(message?.message)
                }}
              />
              &nbsp;
              {`${message?.status}`}
              {message?.user && (
                <>
                  &nbsp;
                  <TextStyle>{` by `}</TextStyle>
                  &nbsp;
                  <TextStyle variation="strong">
                    {`${message?.user?.firstName} ${message?.user?.lastName}`}
                  </TextStyle>
                </>
              )}
            </div>
          </StyledNote>
        </CSSTransition>
      </SwitchTransition>
    </Tag>
  );
}

export default MilestoneBubble;
